export function dataInRequest(params = {}) {
    return {
        type: '@apuracaoInventario/DATA_IN_REQUEST',
        payload: { params },
    };
}

export function findData(id) {
    return {
        type: '@apuracaoInventario/FIND_DATA',
        payload: { id },
    };
}

export function failedRequest() {
    return {
        type: '@apuracaoInventario/FAILED_REQUEST',
    };
}

export function deleteData(id, params) {
    return {
        type: '@apuracaoInventario/DELETE_DATA',
        payload: { id, params },
    };
}

export function updateData(data, params) {
    return {
        type: '@apuracaoInventario/UPDATE_DATA',
        payload: { data, params },
    };
}

export function storeData(data, params) {
    return {
        type: '@apuracaoInventario/STORE_DATA',
        payload: { data, params },
    };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
    return {
        type: '@apuracaoInventario/SUCCESS_IN_REQUEST',
        payload: { data, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(data) {
    return {
        type: '@apuracaoInventario/SUCCESS_REQUEST',
        payload: { data },
    };
}

export function successRemove(params) {
    return {
        type: '@apuracaoInventario/SUCCESS_REMOVE',
        payload: { params },
    };
}

export function recordFiltering(params) {
    return {
        type: '@apuracaoInventario/RECORD_FILTERING',
        payload: { params },
    };
}
